import { createBrowserClient } from '@supabase/ssr';

import { fetchWithTransientReadRetry } from '@kit/shared/upstream-error';

import { Database } from '../database.types';
import { getSupabaseClientKeys } from '../get-supabase-client-keys';

/**
 * @name getSupabaseBrowserClient
 * @description Get a Supabase client for use in the Browser
 */
export function getSupabaseBrowserClient<GenericSchema = Database>() {
  const keys = getSupabaseClientKeys();

  return createBrowserClient<GenericSchema>(keys.url, keys.publicKey, {
    global: {
      fetch: fetchWithTransientReadRetry,
    },
  });
}
